import { render, staticRenderFns } from "./UsersView.vue?vue&type=template&id=e20ae74c&lang=pug&"
import script from "./UsersView.vue?vue&type=script&lang=ts&"
export * from "./UsersView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports